import React, { useEffect, useState } from "react";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import { getData, postData } from "../Commonfunction/CommonFunction";
import * as Yup from "yup";
import { toast } from "react-toastify";
import { ErrorMessage, Field, Form, Formik } from "formik";
import CurrencyFormat from "react-currency-format";
import CommonModal from "../common/CommonModal";
import "../../assets/style/AddTax.css";
import FormHeading from "../common/FormHeading";
import CustomersFileHistoryFilter from "./CustomersFileHistoryFilter";
import MultiFIle from "./MultiFIle";

export default function AddTax({ customerFile = false }) {
  const { id } = useParams();
  const navigate = useNavigate();
  const location = useLocation();
  const fileData = location.state?.data;
  const fileYear = location.state?.year;
  const userType = localStorage.getItem("user_type");
  const employeeType = localStorage.getItem("employee_type");
  const [singleData, setSingleData] = useState();
  const [disapproveModal, setDisapproveModal] = useState(false);
  const [windowModal, setWindowModal] = useState(false);
  const [reviewButtonData, setReviewButtonData] = useState(false);
  const [uploadButtonData, setUploadButtonData] = useState(false);
  const [reviewResponse, setReviewResponse] = useState(false);

  const [commanFiled, setCommanFiled] = useState("");
  const [commanFiledLabel, setCommanFiledLabel] = useState("");
  const [commanFiledModal, setCommanFiledModal] = useState(false);

  const formatString = (str) => str.replace(/_/g, " ");

  const formatCurrency = (value) => {
    if (value === undefined || value === null || value === "") return "";
    const number = parseFloat(value);
    if (isNaN(number)) return "";

    // Format number with up to 2 decimal places
    const formatted = new Intl.NumberFormat("en-US", {
      style: "decimal",
      minimumFractionDigits: 0,
      maximumFractionDigits: 2,
    }).format(number);

    // Remove '.00' suffix if the number is an integer
    return formatted.replace(/(\.00)?$/, "");
  };

  const unformatCurrency = (value) => {
    if (value === undefined || value === null || value === "") return "";
    // Remove all non-numeric characters except the decimal point
    return value.replace(/[^0-9.]/g, "");
  };

  const singleCountyData = async () => {
    try {
      const request_url = location.pathname.includes("view-customer-file")
        ? `/api/get-customer-file/${id}`
        : `/api/get-customer-file-by-customer-id/${id}`;
      const result = await getData(request_url);
      if (result.success) {
        setSingleData(result.data);
      } else {
        toast.error(result.message);
      }
    } catch (error) {
      console.log("Error: ", error);
    }
  };

  const validationSchemaDisapproveModal = Yup.object().shape({
    reason: Yup.string().required("Reason is required"),
  });

  const handleSubmit = async (FinalValue) => {
    try {
      const request_url = `/api/update-customer-file/${singleData?.customer_id}`;
      const postDataResult = await postData(request_url, FinalValue);
      toast.success(postDataResult.message);
      navigate("/Client");
    } catch (error) {
      toast.error(error.response.data.message);
    }
  };

  const ApproveDataSubmit = async (reason) => {
    try {
      const request_url = customerFile
        ? `/api/add-client-previous-data/${singleData?.customer_id}`
        : `/api/update-customer-file/${singleData?.customer_id}`;
      const postDataResult = await postData(request_url, reason);
      toast.success(postDataResult.message);
      customerFile
        ? navigate(`/customer-file/${singleData?.customer_id}`, {
            state: { year: fileYear },
          })
        : navigate("/Client");
    } catch (error) {
      toast.error(error?.response?.data?.message);
    }
  };

  const ReviewDataSubmit = async (reason) => {
    try {
      const request_url = `/api/update-customer-file/${singleData?.customer_id}`;
      const postDataResult = await postData(request_url, reason);
      // console.log("adsdsad=>", postDataResult.data.current_month_data)
      setReviewResponse(postDataResult.data.current_month_data);
    } catch (error) {
      // toast.error(error.response.data.message);
    }
  };
  const uploadTaxPanelSubmit = async (reason) => {
    try {
      const request_url = `/api/update-customer-file/${singleData?.customer_id}`;
      const postDataResult = await postData(request_url, reason);
      // console.log("adsdsad=>", postDataResult.data.current_month_data)
      setReviewResponse(postDataResult.data.current_month_data);
    } catch (error) {
      // toast.error(error.response.data.message);
    }
  };
  const DisapproveDataSubmit = async (reason) => {
    try {
      const request_url = `/api/update-customer-file/${singleData?.customer_id}`;
      const postDataResult = await postData(request_url, reason);
      toast.success(postDataResult.message);
      navigate("/Client");
    } catch (error) {
      toast.error(error.response.data.message);
    }
  };

  const [currentMonth, setCurrentMonth] = useState("");

  const maskNumber = (number) => {
    const numberString = number?.toString();
    const lastFourDigits = numberString?.slice(-4);
    const maskedSection = "*"?.repeat(numberString?.length - 4);
    return maskedSection + lastFourDigits;
  };

  useEffect(() => {
    const now = new Date();
    // Calculate the previous month
    const previousMonthDate = new Date(now.setMonth(now.getMonth() - 1));
    // Get the previous month name
    const month = previousMonthDate.toLocaleString("default", {
      month: "long",
    });

    // const month = new Date().toLocaleString('default', { month: 'long' });
    customerFile ? setCurrentMonth(fileData?.month) : setCurrentMonth(month);
    !customerFile && singleCountyData();
    customerFile && setSingleData(fileData);
  }, []);
  // console.log('const fileData = location.state?.data', id, fileData, singleData)
  const boxStyles = {
    background: "#f8fafc",
    padding: "10px",
    border: "1px solid #ddd",
    borderRadius: "10px",
    margin: "auto",
    textAlign: "center",
    cursor: "pointer",
  };
  const textSty = {
    color: "#083162",
    fontWeight: "600",
  };

  const taxTypeData = [
    { label: "Gross Non fule", value: "#7593CE" },
    { label: "High", value: "#BAD9F8" },
    { label: "Low", value: "#F7FBFC" },
    { label: "Gas", value: "#FFE5E4" },
    { label: "Diesel", value: "#F8CACA" },
    { label: "Non Taxable", value: "#7593CE" },
    { label: "Other", value: "#BAD9F8" },
    { label: "GA Tax", value: "#F7FBFC" },
    { label: "Hotel Occupancy", value: "#FFE5E4" },
    { label: "Room Tax", value: "#F8CACA" },
    { label: "Adjustment", value: "#7593CE" },
    { label: "Custom", value: "#7593CE" },
    { label: "Non Food", value: "#BAD9F8" },
    { label: "Food Sales", value: "#F7FBFC" },
    { label: "CBD Sales", value: "#FFE5E4" },
    { label: "Non Taxable Sales", value: "#F8CACA" },
    { label: "Lotto & Non Sales", value: "#7593CE" },
    { label: "Other Misc Info", value: "#BAD9F8" },
    { label: "Calculation Total", value: "#F7FBFC" },
    { label: "Par B S U Distribution", value: "#FFE5E4" },
    { label: "S & U Return", value: "#F8CACA" },
    { label: "Vendor Compensation", value: "#7593CE" },
  ];
  return (
    <>
      <Formik
        enableReinitialize
        initialValues={{
          // ------customer details------
          customer_file_no: id ? singleData?.customer_file_no : "",
          company_name: id ? singleData?.company_name : "",
          dba_name: id ? singleData?.dba_name : "",
          address: id ? singleData?.address : "",
          state: id ? singleData?.state : "",
          city: id ? singleData?.city : "",
          s_and_u_number: id ? singleData?.s_and_u_number : "",
          year: id ? singleData?.year : "",
          month: id ? singleData?.month : "",
          mobile_no: id ? singleData?.mobile_no : "",

          // ------tax composition details------

          state_tax: id ? singleData?.state_tax : "",
          county_tax: id ? singleData?.county_tax : "",
          total_ga_tax: id ? singleData?.total_ga_tax : "",
          vendor_comp_above: id ? singleData?.vendor_comp_above : 0,
          vendor_comp_below: id ? singleData?.vendor_comp_below : 0,

          off_road_fuel: id ? singleData?.off_road_fuel : 0,
          on_road_fuel: id ? singleData?.on_road_fuel : 0,
          local_tax: id ? singleData?.local_tax : 0,
          cbd_sales: id ? singleData?.cbd_sales : 0,
          non_food: id ? singleData?.non_food : 0,
          food_sales: id ? singleData?.food_sales : 0,

          //--------bank details---------
          website: id ? singleData?.website : "",
          username: id ? singleData?.username : "",
          password: id ? singleData?.password : "",
          bank_name: id ? singleData?.bank_name : "",
          bank_branch: id ? singleData?.bank_branch : "",
          bank_account_no: id ? singleData?.bank_account_no : "",
          routing_number: id ? singleData?.routing_number : "",
          bank_micr_code: id ? singleData?.bank_micr_code : "",
          account_holder_name: id ? singleData?.account_holder_name : "",
          newFiled: "",
          //--------tax-heads-details---------
          tax_head: id
            ? customerFile
              ? { [singleData?.month]: singleData?.tax_head }
              : singleData?.previous_months_tax_heads
            : "",
        }}
        onSubmit={(values) => {
          const FinalValue = {
            tax_head: values.tax_head[currentMonth],
            month: currentMonth,
            submit_for_review: 1,
          };
          handleSubmit(FinalValue);
          // onClose();
        }}
      >
        {({ errors, touched, values, setFieldValue }) => (
          <Form>
            {/* <FormHeading
              heading={"Client File Details"}
              path={
                customerFile
                  ? `/customer-file/${singleData?.customer_id}`
                  : "/all-clients"
              }
            /> */}

            <div className="client-file-container">
              <div className="client-info-card">
                <FormHeading
                  heading={"Client File Details"}
                  path={
                    customerFile
                      ? `/customer-file/${singleData?.customer_id}`
                      : "/Client"
                  }
                />
                <div className="info-grid">
                  <div className="info-item">
                    <label>Customer File No</label>
                    <span>{values?.customer_file_no}</span>
                  </div>
                  <div className="info-item">
                    <label>Company Name</label>
                    <span>{values?.company_name}</span>
                  </div>
                  <div className="info-item">
                    <label>DBA Name</label>
                    <span>{values?.dba_name}</span>
                  </div>
                  <div className="info-item">
                    <label>S&U Number</label>
                    <span>{values?.s_and_u_number}</span>
                  </div>
                  <div className="info-item">
                    <label>Year</label>
                    <span>{values?.year}</span>
                  </div>
                  <div className="info-item">
                    <label>Month</label>
                    <span>{currentMonth}</span>
                  </div>
                  <div className="info-item">
                    <label>Mobile Number</label>
                    <span>{values?.mobile_no}</span>
                  </div>
                  <div className="info-item">
                    <label>Account Number</label>
                    <span>
                      {values?.bank_account_no?.length > 6
                        ? maskNumber(values?.bank_account_no)
                        : values?.bank_account_no}
                    </span>
                  </div>
                  <div className="info-item">
                    <label>State</label>
                    <span>{singleData?.state_name}</span>
                  </div>
                  <div className="info-item">
                    <label>City</label>
                    <span>{singleData?.city}</span>
                  </div>
                  <div className="info-item">
                    <label>Zipcode</label>
                    <span>{singleData?.zipcode}</span>
                  </div>
                </div>
              </div>

              {customerFile && (
                <div className="tax-rates-card">
                  <h3>Tax Rates Information</h3>
                  <div className="rates-grid">
                    <div
                      className="rate-item"
                      onClick={() => {
                        setCommanFiled("state_tax");
                        setCommanFiledLabel("State Tax");
                        setCommanFiledModal(true);
                      }}
                    >
                      <div className="rate-label">State Tax</div>
                      <div className="rate-value">{values.state_tax || 0}%</div>
                    </div>

                    <div
                      className="rate-item"
                      onClick={() => {
                        setCommanFiled("county_tax");
                        setCommanFiledLabel("County Tax");
                        setCommanFiledModal(true);
                      }}
                    >
                      <div className="rate-label">County Tax</div>
                      <div className="rate-value">
                        {values.county_tax || 0}%
                      </div>
                    </div>

                    <div className="rate-item total-tax">
                      <div className="rate-label">Total Tax</div>
                      <div className="rate-value">
                        {parseFloat(values?.state_tax || 0) +
                          parseFloat(values?.county_tax || 0)}
                        %
                      </div>
                    </div>

                    <div
                      className="rate-item"
                      onClick={() => {
                        setCommanFiled("food_sales");
                        setCommanFiledLabel("Food Sales");
                        setCommanFiledModal(true);
                      }}
                    >
                      <div className="rate-label">Food Sales</div>
                      <div className="rate-value">
                        {values.food_sales || 0}%
                      </div>
                    </div>

                    <div
                      className="rate-item"
                      onClick={() => {
                        setCommanFiled("non_food");
                        setCommanFiledLabel("Non-Food");
                        setCommanFiledModal(true);
                      }}
                    >
                      <div className="rate-label">Non-Food</div>
                      <div className="rate-value">{values.non_food || 0}%</div>
                    </div>

                    <div
                      className="rate-item"
                      onClick={() => {
                        setCommanFiled("cbd_sales");
                        setCommanFiledLabel("CBD Sales");
                        setCommanFiledModal(true);
                      }}
                    >
                      <div className="rate-label">CBD Sales</div>
                      <div className="rate-value">{values.cbd_sales || 0}%</div>
                    </div>

                    <div
                      className="rate-item"
                      onClick={() => {
                        setCommanFiled("local_tax");
                        setCommanFiledLabel("Local Sales");
                        setCommanFiledModal(true);
                      }}
                    >
                      <div className="rate-label">Local Sales</div>
                      <div className="rate-value">{values.local_tax || 0}%</div>
                    </div>

                    <div
                      className="rate-item"
                      onClick={() => {
                        setCommanFiled("vendor_comp_above");
                        setCommanFiledLabel("Vendor Comp (Below $3000)");
                        setCommanFiledModal(true);
                      }}
                    >
                      <div className="rate-label">
                        Vendor Comp (Below $3000)
                      </div>
                      <div className="rate-value">
                        {values.vendor_comp_above || 0}%
                      </div>
                    </div>

                    <div
                      className="rate-item"
                      onClick={() => {
                        setCommanFiled("vendor_comp_below");
                        setCommanFiledLabel("Vendor Comp (Above $3000)");
                        setCommanFiledModal(true);
                      }}
                    >
                      <div className="rate-label">
                        Vendor Comp (Above $3000)
                      </div>
                      <div className="rate-value">
                        {values.vendor_comp_below || 0}%
                      </div>
                    </div>

                    <div
                      className="rate-item"
                      onClick={() => {
                        setCommanFiled("on_road_fuel");
                        setCommanFiledLabel("On Road Fuel");
                        setCommanFiledModal(true);
                      }}
                    >
                      <div className="rate-label">On Road Fuel</div>
                      <div className="rate-value">
                        {values.on_road_fuel || 0}%
                      </div>
                    </div>

                    <div
                      className="rate-item"
                      onClick={() => {
                        setCommanFiled("off_road_fuel");
                        setCommanFiledLabel("Off Road Fuel");
                        setCommanFiledModal(true);
                      }}
                    >
                      <div className="rate-label">Off Road Fuel</div>
                      <div className="rate-value">
                        {values.off_road_fuel || 0}%
                      </div>
                    </div>
                  </div>
                </div>
              )}

              <div className="tax-heads-card">
                <div
                  style={{ display: "flex", justifyContent: "space-between" }}
                >
                  <h3>Tax Heads Details</h3>{" "}
                  <div style={{ gap: "10px" }}>
                    {!customerFile && (
                      <div
                        className="cursor-pointer text-bold"
                        style={{
                          display: "flex",
                          alignItems: "center",
                          color: "#2727ce",
                        }}
                      >
                        <button
                          type="button"
                          className="usa-button"
                          onClick={() => setWindowModal(true)}
                          style={{
                            padding: "0.25rem 1rem",
                            borderRadius: "10px",
                            display: "flex",
                            alignItems: "center",
                          }}
                        >
                          <svg
                            xmlns="http://www.w3.org/2000/svg"
                            height="1em"
                            viewBox="0 0 576 512"
                            fill="currentColor"
                            style={{ marginRight: "5px" }}
                          >
                            <path d="M572.5 241.4C518.4 135.5 407.5 64 288 64S57.63 135.5 3.516 241.4a48.076 48.076 0 0 0 0 29.2C57.63 376.5 168.5 448 288 448s230.4-71.5 284.5-177.4a48.076 48.076 0 0 0 0-29.2zM288 400c-88.2 0-167.2-52.7-211.9-136C120.8 180.7 199.8 128 288 128s167.2 52.7 211.9 136C455.2 347.3 376.2 400 288 400zm0-240c-57.4 0-104 46.6-104 104s46.6 104 104 104 104-46.6 104-104-46.6-104-104-104zm0 160c-30.9 0-56-25.1-56-56s25.1-56 56-56 56 25.1 56 56-25.1 56-56 56z" />
                          </svg>
                          View History
                        </button>
                      </div>
                    )}
                  </div>
                </div>
                <div className="tax-table-wrapper">
                  <table className="tax-table">
                    <thead>
                      <tr>
                        <th>Tax Head Type</th>
                        <th>Tax Head</th>
                        {values?.tax_head &&
                          Object.keys(values.tax_head).map((month, index) => (
                            <th
                              key={index}
                              className={
                                month === currentMonth ? "current-month" : ""
                              }
                            >
                              {month}
                            </th>
                          ))}
                        <th className="total-column">Total</th>
                      </tr>
                    </thead>
                    <tbody>
                      {Object.keys(values?.tax_head?.[currentMonth] || {}).map(
                        (category, categoryIndex) => (
                          <React.Fragment key={categoryIndex}>
                            {values.tax_head[currentMonth][category].map(
                              (item, itemIndex) => {
                                const rowTotal = Object.keys(
                                  values.tax_head
                                ).reduce((sum, month) => {
                                  const itemKey = Object.keys(item)[0];
                                  const itemValue =
                                    values.tax_head[month]?.[category]?.[
                                      itemIndex
                                    ]?.[itemKey] || "0";
                                  const itemValueString = String(itemValue);
                                  const numericValue = parseFloat(
                                    itemValueString.replace(/,/g, "")
                                  );
                                  return sum + numericValue;
                                }, 0);

                                return (
                                  <tr
                                    key={itemIndex}
                                    className={
                                      itemIndex % 2 === 0
                                        ? "even-row"
                                        : "odd-row"
                                    }
                                  >
                                    {itemIndex === 0 && (
                                      <td
                                        rowSpan={
                                          values.tax_head[currentMonth][
                                            category
                                          ].length
                                        }
                                        className="category-cell"
                                        style={{
                                          backgroundColor: (() => {
                                            const label = category.replace(
                                              /[_-]/g,
                                              " "
                                            );
                                            const match = taxTypeData.find(
                                              (item) => item.label === label
                                            );
                                            return match ? match.value : "#fff";
                                          })(),
                                        }}
                                      >
                                        {category.replace(/[_-]/g, " ")}
                                      </td>
                                    )}
                                    <td className="tax-head-name">
                                      {formatString(Object.keys(item)[0])}
                                    </td>
                                    {Object.keys(values.tax_head).map(
                                      (month, monthIndex) => (
                                        <td
                                          key={monthIndex}
                                          className={`amount-cell ${
                                            month === currentMonth
                                              ? "editable-cell"
                                              : ""
                                          }`}
                                        >
                                          <div className="currency-input-container">
                                            <span className="currency-symbol">
                                              $
                                            </span>
                                            <Field
                                              name={`tax_head.${month}.${category}[${itemIndex}].${
                                                Object.keys(item)[0]
                                              }`}
                                            >
                                              {({ field, form }) => (
                                                <CurrencyFormat
                                                  {...field}
                                                  thousandSeparator={true}
                                                  decimalScale={2}
                                                  fixedDecimalScale={true}
                                                  allowNegative={true}
                                                  onValueChange={({
                                                    value,
                                                  }) => {
                                                    setFieldValue(
                                                      field.name,
                                                      value
                                                    );
                                                  }}
                                                  value={field.value || ""}
                                                  className="currency-input"
                                                  placeholder="0.00"
                                                  disabled={
                                                    month !== currentMonth
                                                  }
                                                />
                                              )}
                                            </Field>
                                          </div>
                                        </td>
                                      )
                                    )}
                                    <td className="total-cell">
                                      <CurrencyFormat
                                        value={rowTotal.toFixed(2)}
                                        displayType={"text"}
                                        thousandSeparator={true}
                                        prefix={"$"}
                                        renderText={(value) => (
                                          <div className="row-total">
                                            {value}
                                          </div>
                                        )}
                                      />
                                    </td>
                                  </tr>
                                );
                              }
                            )}
                          </React.Fragment>
                        )
                      )}
                    </tbody>
                  </table>
                </div>
              </div>

              <div className="action-buttons-container">
                {!location.pathname.includes("view-customer-file") && (
                  <div className="action-buttons">
                    {employeeType === "email_operator" && (
                      <button type="submit" className="primary-button">
                        Save As Draft
                      </button>
                    )}

                    {employeeType === "reviewer" && (
                      <button
                        type="button"
                        className="primary-button"
                        onClick={() =>
                          ApproveDataSubmit({
                            month: currentMonth,
                            tax_panel_ready: 1,
                          })
                        }
                      >
                        Approve & Pass To Team Lead
                      </button>
                    )}

                    {(employeeType === "team_lead" || userType === "CPA") &&
                      singleData?.file_status === "tax_panel_ready" && (
                        <button
                          type="button"
                          className="primary-button"
                          onClick={() =>
                            ApproveDataSubmit({
                              month: currentMonth,
                              uploaded_to_portal: 1,
                            })
                          }
                        >
                          Upload To Tax Portal
                        </button>
                      )}

                    {(employeeType === "data_entry_operator" ||
                      userType === "CPA") && (
                      <>
                        <button
                          type="button"
                          className="secondary-button"
                          onClick={() => {
                            const FinalValue = {
                              tax_head: values.tax_head[currentMonth],
                              month: currentMonth,
                              tax_panel_ready: 1,
                            };
                            ReviewDataSubmit(FinalValue);
                            setReviewButtonData(true);
                          }}
                        >
                          Review
                        </button>

                        <button
                          disabled={
                            userType === "CPA"
                              ? false
                              : singleData?.file_status === "data_approved"
                              ? true
                              : false
                          }
                          type="button"
                          className="primary-button"
                          onClick={() => {
                            const FinalValue = {
                              tax_head: values.tax_head[currentMonth],
                              month: currentMonth,
                              data_approved: 1,
                            };
                            ApproveDataSubmit(FinalValue);
                          }}
                        >
                          Approve
                        </button>

                        {singleData?.file_status === "data_approved" && (
                          <button
                            type="button"
                            className="secondary-button"
                            onClick={() => {
                              setUploadButtonData(true);
                            }}
                          >
                            Document
                          </button>
                        )}

                        <button
                          type="button"
                          className="danger-button"
                          onClick={() => setDisapproveModal(true)}
                        >
                          Reject
                        </button>
                      </>
                    )}
                  </div>
                )}

                {customerFile && (
                  <div className="action-buttons">
                    {(employeeType === "data_entry_operator" ||
                      userType === "CPA") && (
                      <button
                        disabled={
                          userType === "CPA"
                            ? false
                            : singleData?.file_status === "data_approved"
                            ? true
                            : false
                        }
                        type="button"
                        className="primary-button"
                        onClick={() => {
                          const months = {
                            january: 1,
                            february: 2,
                            march: 3,
                            april: 4,
                            may: 5,
                            june: 6,
                            july: 7,
                            august: 8,
                            september: 9,
                            october: 10,
                            november: 11,
                            december: 12,
                          };
                          const dataMonth = months[values.month.toLowerCase()];
                          const FinalValue = {
                            tax_head: values.tax_head[currentMonth],
                            month: dataMonth,
                            year: values.year,
                            state_tax: values?.state_tax,
                            county_tax: values?.county_tax,
                            total_ga_tax:
                              parseFloat(values?.state_tax) +
                              parseFloat(values?.county_tax),
                            vendor_comp_above: values.vendor_comp_above,
                            vendor_comp_below: values.vendor_comp_below,
                            off_road_fuel: values?.off_road_fuel,
                            on_road_fuel: values?.on_road_fuel,
                            local_tax: values?.local_tax,
                            cbd_sales: values?.cbd_sales,
                            non_food: values?.non_food,
                            food_sales: values?.food_sales,
                            data_approved: 1,
                          };
                          ApproveDataSubmit(FinalValue);
                        }}
                      >
                        Approve
                      </button>
                    )}
                  </div>
                )}
              </div>
            </div>

            {commanFiledModal && (
              <div className="modal-overlay">
                <div className="modal-content">
                  <h3 className="modal-title">Update {commanFiledLabel}</h3>
                  <div className="modal-body">
                    <div className="old-value">
                      Old {commanFiledLabel} Value: {singleData[commanFiled]} %
                    </div>
                    <Field
                      id={commanFiled}
                      className="modal-input"
                      name="newFiled"
                      type="number"
                      placeholder={`Enter New ${commanFiledLabel}`}
                      min={0}
                      max={100}
                      step={0.01}
                    />
                    <div className="modal-buttons">
                      <button
                        type="button"
                        className="modal-submit"
                        onClick={() => {
                          setFieldValue(`${commanFiled}`, values.newFiled);
                          setCommanFiledModal(false);
                          setCommanFiled("");
                          setCommanFiledLabel("");
                          setFieldValue(
                            `total_ga_tax`,
                            parseFloat(values?.state_tax) +
                              parseFloat(values?.county_tax)
                          );
                          setFieldValue(`newFiled`, "");
                        }}
                      >
                        Submit
                      </button>
                      <button
                        type="button"
                        className="modal-cancel"
                        onClick={() => {
                          setCommanFiledModal(false);
                          setCommanFiled("");
                          setCommanFiledLabel("");
                          setFieldValue(`newFiled`, "");
                        }}
                      >
                        Cancel
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            )}
          </Form>
        )}
      </Formik>
      {disapproveModal && (
        <CommonModal
          open={disapproveModal}
          onClose={() => setDisapproveModal(false)}
          title={"Disapprove"}
        >
          <div>
            <Formik
              enableReinitialize
              initialValues={{
                reason: "",
                data_approved: 0,
              }}
              validationSchema={validationSchemaDisapproveModal}
            >
              {({ errors, touched, values }) => (
                <Form>
                  <div className="form-group">
                    <label htmlFor="reason">
                      Reason <span className="usa-label--required">*</span>
                    </label>
                    <Field
                      id="reason"
                      name="reason"
                      placeholder="Please enter reason"
                    />
                    <ErrorMessage
                      name="reason"
                      component="div"
                      className="error-message"
                    />
                  </div>
                  <div className="form-footer">
                    <button
                      type="button"
                      className="btn btn-cancel"
                      onClick={() => setDisapproveModal(false)}
                    >
                      Cancel
                    </button>
                    <button
                      type="submit"
                      className="btn btn-submit"
                      onClick={() => {
                        if (values.reason) {
                          DisapproveDataSubmit(values);
                        }
                      }}
                    >
                      Submit
                    </button>
                  </div>
                </Form>
              )}
            </Formik>
          </div>
        </CommonModal>
      )}
      {reviewButtonData && (
        <CommonModal
          open={reviewButtonData}
          onClose={() => setReviewButtonData(false)}
          title={"Review Data"}
          size="large"
          dashboardView="dashboardView"
        >
          <CustomersFileHistoryFilter
            addTax={true}
            onClose={() => setReviewButtonData(false)}
            isSingleMonth={true}
          />
        </CommonModal>
      )}
      {uploadButtonData && (
        <CommonModal
          open={uploadButtonData}
          onClose={() => setUploadButtonData(false)}
          title={"Document"}
          size="extra_large"
          dashboardView="dashboardView"
        >
          <MultiFIle
            custData={singleData}
            onClose={true}
            closeModal={setUploadButtonData}
          />
        </CommonModal>
      )}
      {windowModal && (
        <CommonModal
          open={windowModal}
          onClose={() => setWindowModal(false)}
          title={"View History"}
        >
          <div className="usa-prose">
            <div className="text-center padding-y-2 font-sans-lg">
              View Customer File History
            </div>

            <div className="display-flex flex-justify-center flex-align-center gap-1 margin-top-2">
              <button
                type="button"
                className="usa-button"
                onClick={() => {
                  window.open(
                    `/tax-history/${id}`,
                    "newwindow",
                    "width=800,height=600,scrollbars=yes"
                  );
                  setWindowModal(false);
                }}
              >
                Open in new window
              </button>

              <button
                type="button"
                className="usa-button usa-button--outline"
                onClick={() => {
                  window.open(`/tax-history/${id}`, "_blank");
                  setWindowModal(false);
                }}
              >
                Open in new tab
              </button>
            </div>
          </div>
        </CommonModal>
      )}
    </>
  );
}
